import { render } from "./HomePGMofTexas.vue?vue&type=template&id=486364fa&ts=true"
import script from "./HomePGMofTexas.vue?vue&type=script&lang=ts"
export * from "./HomePGMofTexas.vue?vue&type=script&lang=ts"

import exportComponent from "/src/ceotrammell_/ceotrammell-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__